module.exports = __webpack_public_path__ + "static/img/TiktokPic.5ddf63a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TiktokPic.jpg
// module id = Eqm/
// module chunks = 101